exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media print{.formmodello{display:none}.dastampare{-webkit-transform:rotate(-90deg);-moz-transform:rotate(-90deg)}}", ""]);

// exports
